import { takeLatest, all } from 'redux-saga/effects';
import {
  SCROLL_TO_PRICE,
  SCROLL_TO_REVIEWS,
  SCROLL_TO_SECTION,
} from '../constants/view';
import { COMPONENT_ID } from '../../constants';
import { scrollToElement } from '../../../../utils/domUtils';

/**
 * Ждет элемент и вызывает скролл к нему
 * @param {string} elementId
 */
function handleScrollToElement(elementId) {
  const element = document.getElementById(elementId);

  if (element) {
    scrollToElement(element);
  }
}

function* handleScrollToSection({ payload }) {
  yield handleScrollToElement(payload);
}
function* handleScrollToPrice() {
  yield handleScrollToElement(COMPONENT_ID.SEARCHER);
}

function* handleScrollToReviews() {
  yield handleScrollToElement(COMPONENT_ID.REVIEWS);
}

export default function* () {
  yield all([
    takeLatest(SCROLL_TO_PRICE, handleScrollToPrice),
    takeLatest(SCROLL_TO_REVIEWS, handleScrollToReviews),
    takeLatest(SCROLL_TO_SECTION, handleScrollToSection),
  ]);
}
